import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Icon from "@client.components/Icon";
import { useDispatch } from "react-redux";
import { processLoginAsync } from "@client.pages/Login/reducer";
import config from "@client.config";

const MicrosoftLogin = ({ hide }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(window.location.search);
  const email = queryParams.get("m");
  const token = queryParams.get("t");

  const handleLogin = async () => {
    const codeChallenge = config.microsoft.codeChallenge;
    const clientId = config.microsoft.auth.clientId;
    const redirectUri = `${config.apiUrl}/microsoft/auth`;
    const scope = ["email", "openid", "profile", "Calendars.Read"].join(" ");
    const state = window.location.host.split(".")[0];
    const microsoftAuthUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&response_mode=query&scope=${scope}&code_challenge=${codeChallenge}&code_challenge_method=S256&state=${state}&prompt=consent`;

    window.location.href = microsoftAuthUrl;
  };

  useEffect(() => {
    if (email && token) {
      dispatch(
        processLoginAsync({
          email,
          token,
          isGoogle: false,
        })
      );
    }
  }, [dispatch, email, token]);

  return (
    !hide && (
      <>
        <button className="microsoft" onClick={handleLogin}>
          <Icon name="microsoft" />
          {t("components.MicrosoftLogin.signin")}
        </button>
      </>
    )
  );
};

MicrosoftLogin.propTypes = {
  hide: PropTypes.bool,
};

export default MicrosoftLogin;
